import { render } from "./PreviewDick.vue?vue&type=template&id=74234929"
import script from "./PreviewDick.vue?vue&type=script&lang=js"
export * from "./PreviewDick.vue?vue&type=script&lang=js"

import "./PreviewDick.vue?vue&type=style&index=0&id=74234929&lang=css"
script.render = render

export default script